// extracted by mini-css-extract-plugin
module.exports = {"crumb":"breadcrumbs_crumb__n_It7","wrapper":"breadcrumbs_wrapper__ao4o8"};